// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"86ec13c8","602":"5044baf0","662":"767f7f3d","692":"2f15c4a4","790":"c194849d","815":"2f15c4a4","843":"9d8621ff","887":"5044baf0"}[chunkId] + ".chunk.css";
};